import React from 'react';
import { FormText, FormFile } from '~/components/FormControl';
import { Row, InputGroup } from 'react-bootstrap';
import { checkDuplicateName } from '~/utils/validators.yup';
import CKEditor from '~/components/CKEditor';
import PropTypes from 'prop-types';
import ColorPickerButton from '~/components/ColorPickerButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';

function CardInput({
    apiPrefix,
    initialValues,
    setConvertedContent,
    setTempUrl,
    nameColor,
    setNameColor,
    frontSides,
    description,
}) {
    const asyncApiCall = checkDuplicateName(initialValues.name, apiPrefix);

    return (
        <>
            <FormText
                inline
                as={Row}
                name="name"
                asyncApiCall={asyncApiCall}
                inputGroupPrepend={
                    <InputGroup.Prepend>
                        <InputGroup.Text>
                            <ColorPickerButton
                                label={<FontAwesomeIcon icon={faPencil} />}
                                color={nameColor}
                                setColor={setNameColor}
                                fieldName={'nameColor'}
                            />
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                }
            />

            <CKEditor
                fieldName="description"
                setConvertedContent={setConvertedContent}
                description={description}
                inline
                as={Row}
                className="mt-4"
            />

            {frontSides.map((name, i) => {
                if (!name.includes('template'))
                    return (
                        <FormFile
                            inline
                            as={Row}
                            name={name}
                            onChangePicture={(fileObj) => {
                                setTempUrl((prev) => {
                                    const nameSplit = name.split('.');
                                    return {
                                        ...prev,
                                        [nameSplit.at(-1)]: URL.createObjectURL(fileObj),
                                    };
                                });
                            }}
                            sm={12}
                            key={i}
                            className="mt-4"
                        />
                    );
            })}
        </>
    );
}

CardInput.propTypes = {
    apiPrefix: PropTypes.string.isRequired,
    initialValues: PropTypes.object.isRequired,
    setConvertedContent: PropTypes.func.isRequired,
    setTempUrl: PropTypes.func.isRequired,
    nameColor: PropTypes.string.isRequired,
    setNameColor: PropTypes.func.isRequired,
    frontSides: PropTypes.array.isRequired,
    description: PropTypes.object.isRequired,
};

export default React.memo(CardInput);
